import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Equipe } from '../models/equipe';
import { TeamsService } from '../teams.service';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { LoaderService } from 'src/app/loader/loader.service';
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-teams-delete',
  templateUrl: './teams-delete.component.html',
  styleUrls: ['./teams-delete.component.scss'],
})
export class TeamsDeleteComponent implements OnInit {
  env;
  team: Equipe;

  timeoutIDError;

  dropdownList = [];
  dropdownSettings: IDropdownSettings = {};

  @ViewChild('alertError', { read: ElementRef, static: false })
  alertError: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private teamsService: TeamsService,
    private loaderService: LoaderService,
    private renderer: Renderer2
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.setCompaniesDropdown();
    this.getTeam(this.route.snapshot.paramMap.get('id'));
  }

  async getTeam(id: string) {
    const loader = await this.loaderService.notifica({
      title: 'Buscando equipe...',
      date: moment().toISOString(),
      type: 'loading',
    });

    this.team = await this.teamsService.getTeam(id).toPromise();

    this.filterCompaniesByUserPermissions();

    loader.dismiss();
  }

  private filterCompaniesByUserPermissions() {
    this.team.empresas = this.team.empresas.filter(company => {
      for (let userCompany of this.env.user.empresas) {
        if (company.cnpj === userCompany.cnpj) {
          return true;
        }
      }
      return false;
    });
  }

  private setCompaniesDropdown() {
    this.dropdownList = this.env.user.empresas;

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'cnpj',
      textField: 'fantasia',
      selectAllText: 'Selecionar Todos',
      unSelectAllText: 'Deselecionar Todos',
      itemsShowLimit: 4,
      allowSearchFilter: true,
      searchPlaceholderText: 'Pesquisar',
    };
  }

  async deleteTeam(id: string) {
    const loader = await this.loaderService.notifica({
      title: 'Deletando equipe...',
      date: moment().toISOString(),
      type: 'loading',
    });

    const deletedTeam = await this.teamsService.deleteTeam(id).toPromise();

    if ('error' in deletedTeam) {
      this.addErrorAlert(deletedTeam.error);
    } else {
      this.router.navigateByUrl(`/teams/${this.env.selected.cnpj}`);
    }

    loader.dismiss();
  }

  addErrorAlert(msg: string) {
    clearTimeout(this.timeoutIDError);

    this.renderer.setProperty(this.alertError.nativeElement, 'innerHTML', msg);
    this.renderer.setProperty(this.alertError.nativeElement, 'hidden', false);

    this.timeoutIDError = setTimeout(_ => {
      this.renderer.setProperty(this.alertError.nativeElement, 'hidden', true);
    }, 8000);
  }

  goBack(): void {
    this.router.navigateByUrl(`/teams/${this.env.selected.cnpj}`);
  }
}
